
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.813 8.195c.567-.77.851-1.932.851-3.484 0-1.37-.281-2.438-.844-3.203 1.073.64 1.61 1.737 1.61 3.289 0 1.531-.54 2.664-1.617 3.398zM2.516 1.5c-.573.885-.86 2.018-.86 3.398 0 1.25.274 2.334.82 3.25C1.425 7.456.899 6.346.899 4.82c0-1.567.54-2.674 1.618-3.32zm5.843 3.352c0-2.495-.906-3.743-2.718-3.743-1.776 0-2.664 1.279-2.664 3.836 0 2.407.898 3.61 2.695 3.61 1.792 0 2.687-1.235 2.687-3.703zM7.258 8.836c.646 0 1.143.07 1.492.21.349.142.953.472 1.813.993 1.421.86 2.481 1.29 3.18 1.29.572 0 1.064-.15 1.476-.446l.078.101c-.469.547-1.06.82-1.774.82-.791 0-1.903-.445-3.335-1.335a36.583 36.583 0 00-1.024-.625 11.12 11.12 0 00-.672-.375 3.48 3.48 0 00-.851-.281 5.97 5.97 0 00-1.172-.094c.547.12 1.531.646 2.953 1.578 1.427.932 2.586 1.469 3.476 1.61-.312.109-.58.163-.804.163-.464 0-.953-.122-1.469-.367-.526-.25-1.247-.703-2.164-1.36-1.208-.864-2.083-1.372-2.625-1.523a2.672 2.672 0 01-.219.008c-1.005 0-1.818-.372-2.437-1.117-.62-.745-.93-1.828-.93-3.25 0-1.412.302-2.495.906-3.25C3.76.84 4.59.469 5.641.469c1.057 0 1.898.37 2.523 1.11.62.744.93 1.832.93 3.265 0 2.015-.612 3.346-1.836 3.992z","fill":"currentColor"}})])
          )
        }
      }
    